(function(doc, win) {
    const docEl = doc.documentElement,
        resizeEvt =
            "orientationchange" in window
                ? "orientationchange"
                : "resize",
        recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            const fontSizeNumber =
                clientWidth > 750 ? 100 : 100 * (clientWidth / 750);
            docEl.style.fontSize = fontSizeNumber + "px";
            const appEl = document.getElementById("app");
            if (
                clientWidth <= 750 &&
                clientWidth !== appEl!.offsetWidth
            ) {
                docEl.style.fontSize =
                    (fontSizeNumber * clientWidth) / appEl!.offsetWidth + "px";
            }
        };
    if (docEl.clientWidth > 767) return;
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);